import { phoneInputFormat as phoneFormatter } from 'util/formatters'

type PharmacyInfoProps = {
  // TODO - improve pharmacy type
  pharmacy: any
}

const PharmacyInfo = ({ pharmacy }: PharmacyInfoProps) => {
  if (!pharmacy) {
    return null
  }

  const { address1, address2, city, primaryFax, fax, primaryPhone, phone, state, storeName, zipCode } = pharmacy

  return (
    <div className="typography-body-l">
      <p className="typography-caption text-neutral-500">Pharmacy</p>
      <p className="typography-body-xl font-semibold mt-1.5 mb-2 text-primary-800">{storeName || '-'}</p>
      <p>{`${address1} ${address2}`.trim() || '-'}</p>
      <p>{`${city}, ${state} ${zipCode}` || '-'}</p>
      <p>{phoneFormatter(primaryPhone || phone) || '-'}</p>
      <p>Fax {phoneFormatter(primaryFax || fax) || '-'}</p>
    </div>
  )
}

export default PharmacyInfo
